var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendBackwardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 473 383.7",
    style: {
      enableBackground: "new 0 0 473 383.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 5.12646484375, 0, 0, -5.12646484375, 80.15,670.4) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Symbol_2_0_Layer0_0_FILL_00000107553152177683802890000001207536035704676487_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.9,109.4c2.3-1.8,2.3-3.8,0-6L45.1,88.6v7.2l20.4,10l-35,16.9l-34.9-16.9l20.4-10v-7.2l-29.9,14.8 c-2.3,2.2-2.3,4.1,0,6l44.3,21.4L74.9,109.4 M50,77.9c0.9-0.9,1.1-2.2,0.6-4L33.7,57.7c-1.2-1.1-2.2-1.6-3.2-1.7 c-1,0.1-2.1,0.7-3.2,1.7L10.4,73.9c-0.5,1.8-0.3,3.1,0.6,4c0.8,0.9,2.1,1.1,4,0.6l12.4-12.1v44.9c0.1,0.1,0.1,0.2,0.2,0.2 c0.9,1,1.8,1.5,2.8,1.4c1,0.1,1.9-0.4,2.9-1.4c0.1-0.1,0.1-0.1,0.2-0.2V66.4L46,78.5C47.8,78.9,49.2,78.7,50,77.9z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendBackwardIcon);
export default __webpack_public_path__ + "static/media/send_backward_icon.b99aee5b.svg";
export { ForwardRef as ReactComponent };